import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import FormattedMoney from '@app/shop/components/FormattedMoney';
import { useOrderHistoryDetail } from './OrderHistoryDetailContext';
import messages from './TotalsRows.messages';

const TotalsRows: FunctionComponent = () => {
  const { itemsData, storeConfig } = useOrderHistoryDetail();
  const includingTax = storeConfig?.taxSalesDisplayPrice === 'including';

  return (
    <>
      {itemsData?.total?.subtotal.value ? (
        <tr>
          <th scope="row" colSpan={3}>
            <FormattedMessage {...messages.subtotal} />
          </th>
          <td data-testid={'history-order-subtotal-value'}>
            {includingTax
              ? itemsData.total?.subtotalIncludingTax && (
                  <FormattedMoney {...itemsData.total?.subtotalIncludingTax} />
                )
              : itemsData.total?.subtotal && (
                  <FormattedMoney {...itemsData.total?.subtotal} />
                )}
          </td>
        </tr>
      ) : null}

      {itemsData?.total?.totalShipping.value ? (
        <tr>
          <th scope="row" colSpan={3}>
            <FormattedMessage {...messages.shippingHandling} />
          </th>
          <td data-testid="history-order-shipping-value">
            <FormattedMoney
              {...itemsData?.total?.shippingHandling?.[
                includingTax ? 'amountIncludingTax' : 'amountExcludingTax'
              ]}
            />
          </td>
        </tr>
      ) : null}

      {itemsData?.total?.subtotal.value ? (
        <tr>
          <th scope="row" colSpan={3}>
            <strong>
              <FormattedMessage {...messages.totalExTax} />
            </strong>
          </th>
          <td>
            <b>
              <FormattedMoney {...itemsData.total.subtotal} />
            </b>
          </td>
        </tr>
      ) : null}

      {itemsData?.total?.discounts?.map((discount) =>
        discount ? (
          <tr key={discount.label}>
            <th scope="row" colSpan={3}>
              <FormattedMessage {...messages.discount} />
            </th>
            <td>
              <FormattedMoney
                currency={discount.amount.currency}
                value={(discount.amount.value || 0) * -1}
              />
            </td>
          </tr>
        ) : null
      ) ?? null}

      {itemsData?.total?.taxes?.map((tax) =>
        tax ? (
          <tr key={tax.title}>
            <th scope="row" colSpan={3} data-testid="history-order-tax-label">
              {includingTax ? (
                tax && <FormattedMessage {...messages.inclTax} />
              ) : (
                <FormattedMessage {...messages.exTax} />
              )}{' '}
              ({tax.title})
            </th>
            <td>
              <FormattedMoney {...tax.amount} />
            </td>
          </tr>
        ) : null
      ) ?? null}

      {itemsData?.total?.grandTotal.value ? (
        <tr>
          <th scope="row" colSpan={3}>
            <strong>
              <FormattedMessage {...messages.totalIncTax} />
            </strong>
          </th>
          <td>
            <b>
              <FormattedMoney {...itemsData?.total.grandTotal} />
            </b>
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default TotalsRows;
